import { LuEllipsisVertical } from 'react-icons/lu'

import { CheckboxToggle } from '@/components/CheckboxToggleInput'

import { ALERT_TEMPLATE_BY_KEY } from '../../constants/alertTemplates'
import { ALERT_SEVERITY_BY_TEMPLATE, AlertTemplateKey } from '../../constants/alertContract'
import { alertHasContacts, type AlertRecord } from '../../api/useAllAlerts'
import { SEVERITY_CONFIG } from '../AlertSeverityBadge'
import styles from './ManageAlertsModal.module.css'

interface AlertCardProps {
  alert: AlertRecord
  isMenuOpen: boolean
  menuRef: React.RefObject<HTMLDivElement | null>
  onToggle: (alert: AlertRecord, enabled: boolean) => void
  onEdit: (alert: AlertRecord) => void
  onDelete: (alert: AlertRecord) => void
  onToggleMenu: (alertId: string | null) => void
}

export const AlertCard = ({
  alert,
  isMenuOpen,
  menuRef,
  onToggle,
  onEdit,
  onDelete,
  onToggleMenu,
}: AlertCardProps) => {
  const severity = ALERT_SEVERITY_BY_TEMPLATE[alert.templateName as AlertTemplateKey]

  return (
    <div className={`${styles.card} ${severity ? styles[`cardBorder_${severity}`] : ''}`}>
      <div className={styles.cardHeader}>
        <div className={styles.cardTitleRow}>
          {severity && (
            <span style={{ color: SEVERITY_CONFIG[severity].color, display: 'flex' }}>
              {SEVERITY_CONFIG[severity].icon}
            </span>
          )}
          <span className={styles.cardTitle}>{alert.title}</span>
        </div>
      </div>
      <div className={styles.cardBody}>
        <span className={styles.cardDescription}>
          {ALERT_TEMPLATE_BY_KEY[alert.templateName as AlertTemplateKey]?.title}
        </span>
      </div>
      <div className={styles.cardFooter}>
        <CheckboxToggle
          checked={alert.enabled}
          disabled={!alertHasContacts(alert) && !alert.enabled}
          onChange={(e) => onToggle(alert, e.target.checked)}
        />
        <div className={styles.kebabContainer} ref={isMenuOpen ? menuRef : null}>
          <button
            className={styles.kebabButton}
            type="button"
            onClick={() => onToggleMenu(isMenuOpen ? null : alert.id)}
          >
            <LuEllipsisVertical size={16} />
          </button>
          {isMenuOpen && (
            <div className={styles.kebabMenu}>
              <button className={styles.kebabMenuItem} type="button" onClick={() => onEdit(alert)}>
                Edit
              </button>
              <button
                className={styles.kebabMenuItem}
                type="button"
                onClick={() => {
                  onToggleMenu(null)
                  onDelete(alert)
                }}
              >
                Delete
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
